// eslint-disable-next-line import/no-default-export -- deprecated usage
export { default } from "./Link";
export type { LinkProps } from "./types";
export * from "./ForwardRefLink";
